import { $one, $all } from "../utils/querySelector";
import { dataToggle } from "../utils/toggleDataActive";
import { closeAll } from "./header";

/**
 * Accordion Action
 * This function change the dataset active in
 * button element accordion (on click event)
 *
 * @param {HTMLElement} element - Button to change data active
 * @param {NodeListOf} accordions - All accordions in DOM
 */
 function accordionAction(element, accordions) {
  if(element.dataset.active === 'false') {
    closeAll('.accordion-item', accordions);
  }
  dataToggle(element);
}

/**
 * Open accordion
 * This function valuate all nodes with the class
 * ".accordions" and add new event listener
 */
export function openAccordion() {
  $all('.accordions').forEach(
    (accordion) => {
      $all('.accordion-item', accordion)
        .forEach((item) => {
          const itemTitle = $one('.accordion-item__title-label', item);
          item.addEventListener(
            'click',
            (e) => {
              e.stopPropagation();
              const accordionItem = e.target.closest('.accordion-item');
              accordionAction(accordionItem, accordion)
            },
          )
          itemTitle.addEventListener(
            'click',
            (e) => {
              e.stopPropagation();
              const url = e.target.dataset.href;
              window.location.href = url;
            },
          )
        })
    },
  )
}